import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';

import { Geolocation } from '@ionic-native/geolocation';

import { MaplistPage } from '../maplist/maplist'
import { MapmodalPage } from '../mapmodal/mapmodal'

import { GlobalsProvider } from '../../providers/globals/globals';

import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/timeout';
import { LoadingController } from 'ionic-angular';

declare var google;
/*declare var map;
declare var infoWindow;*/

@Component({
  selector: 'page-map',
  templateUrl: 'map.html',
})
export class MapPage {

  map: any;
  places: any;
  autocomplete: any;
  infoWindow: any;
  markers = [];
  lat: any;
  lng: any;
  that: any;
  test: string = '0';
  geocoder: any;
  city_lat: any;
  city_lng: any;
  gorod: string = 'Казань';
  objdesc: string = '';
  modalopened: string = '';
  modal: any;
  items: any;
  type: string = 'police';
  id_type: string  = '';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private geolocation: Geolocation,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public params: GlobalsProvider,
    public http: Http
  ) {

    if (navParams.get('gorod')) this.gorod = navParams.get('gorod');
    if (navParams.get('code')) this.type = navParams.get('code');
    if (navParams.get('id')) this.id_type = navParams.get('id');

    let that = this;
    setTimeout(function () {
      that.findCity();  
    }, 50);
  }

  openModal() {

    if (this.modalopened == '1') {
      this.modalopened = '';
      this.modal.dismiss();
    }

    if (this.modalopened == '') {
      this.modal = this.modalCtrl.create(MapmodalPage, { 'desc': this.objdesc }, { cssClass: 'mapmodal', enableBackdropDismiss: true});

      this.modal.present().then(() => {
        this.modalopened = '1';
      });
    }
  }

  findCity() {
    let that = this;
    this.geocoder = new google.maps.Geocoder();
    this.geocoder.geocode({ 'address': this.gorod }, function (results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        that.city_lat = results[0].geometry.location.lat();
        that.city_lng = results[0].geometry.location.lng();
        that.googleMap();
      }
    });
    
  }

  googleMap() {

    let that = this;

    var gStyles =[
        {
            featureType: "poi",
            elementType: "labels",
            stylers: [
                  { visibility: "off" }
            ]
        }
    ];

    this.map = new google.maps.Map(document.getElementById('map'), {
      center: { lat: that.city_lat, lng: that.city_lng  },
      zoom: 13,
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.TOP_RIGHT
      },
      disableDefaultUI: true,
      mapTypeControl: true,
      styles: gStyles 

    });

    this.places = new google.maps.places.PlacesService(this.map);
    

    this.infoWindow = new google.maps.InfoWindow;

    /*var pos = {
      lat: this.lat,
      lng: this.lng 
    };

    console.log(pos.lat + '=='+pos.lng);

    this.infoWindow.setPosition(pos);
    this.infoWindow.setContent('Вы здесь');
    this.infoWindow.open(this.map);
    this.map.setCenter(pos);*/


    /*var marker = new google.maps.Marker({
      position: { lat: 55.79879856893823, lng: 49.11628649999999 },
      icon: '/assets/imgs/geo.png',
      map: that.map
    });
    marker.addListener('click', function () {
      that.infoWindow.setContent('<strong>Отдел Полиции "Япеева"</strong><br><br>Адрес: Казань, ул.Япеева, д.8<br><br>Телефон: +7 (843) 291-33-62');
      that.infoWindow.open(that.map, marker);
    });*/

    if (this.type != 'custom') {
    
      google.maps.event.addListener(that.map, 'bounds_changed', function () {
      //google.maps.event.addListenerOnce(that.map, 'idle', function () {
        that.search();
      });

      google.maps.event.addListener(that.map, 'zoom_changed', function () {
        that.search();
      });

    } else {

      let bounds  = new google.maps.LatLngBounds();

      let loadingPopup = this.loadingCtrl.create({
        content: 'Загрузка'
      });
  
      loadingPopup.present();
  
      this.http.get(this.params.apiURL + '?act=map&gorod='+this.gorod + '&id_type='+this.id_type)
        .timeout(20000)
        .map(res => res.json())
        .subscribe(
          data => {
            this.items = data.items;
            console.log('Кастом объекты карты подгружены');

            let that = this;

            this.clearMarkers();
            
            this.items.forEach(function(item, i) {
              //alert( i + ": " + item.name);
              that.markers[i] = new google.maps.Marker({
                position: { lat: Number(item.lat), lng: Number(item.lng) },
                objdesc: '<strong>' + item.name + '</strong><br><br>' + item.adres + '<br><br>' + item.tel
              });
              let loc = new google.maps.LatLng( that.markers[i].position.lat(),  that.markers[i].position.lng());
              bounds.extend(loc);

              that.markers[i].setMap(that.map);                
              let that2 = that;
              that.markers[i].addListener('click', function () {
                var marker = this;
                that2.objdesc = this.objdesc;
                that2.openModal();
              });                
            });          

            if (that.markers.length == 1)  {
              this.map.setCenter(that.markers[0].position);
            } else {
              this.map.fitBounds(bounds);
              this.map.panToBounds(bounds);                //
            }



            loadingPopup.dismiss();
  
  
          },
  
          err => {
            loadingPopup.dismiss();
            console.log('Ошибка загрузки кастом объектов');
          }
  
        );      
    }

    /*this.map.addListener('click', function (event) {
      that.addMarker(event.latLng);
    });*/

    // Try HTML5 geolocation.
    /*if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        var pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };

        that.infoWindow.setPosition(pos);
        that.infoWindow.setContent('Location found.');
        that.infoWindow.open(that.map);
        that.map.setCenter(pos);
      }, function () {
        this.handleLocationError(true, that.infoWindow, that.map.getCenter());
      });
    } else {
      // Browser doesn't support Geolocation
      this.handleLocationError(false, that.infoWindow, that.map.getCenter());
    }*/
  }

  search() {

    let that = this;

    var search = {
      bounds: that.map.getBounds(),
      types: [that.type]
    };

    //console.log(search);

    this.places.nearbySearch(search, function (results, status) {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        //that.clearResults();
        that.clearMarkers();
        // Create a marker for each hotel found, and
        // assign a letter of the alphabetic to each marker icon.
        for (var i = 0; i < results.length; i++) {
          // Use marker animation to drop the icons incrementally on the map.
          that.markers[i] = new google.maps.Marker({
            position: results[i].geometry.location,
            //animation: google.maps.Animation.DROP,
            //icon: '/assets/imgs/geo.svg',
          });
          that.markers[i].setMap(that.map);
          that.markers[i].placeResult = results[i];

          //google.maps.event.addListener(that.markers[i], 'click', that.showInfoWindow(that.markers[i]));
          let that2 = that;
          that.markers[i].addListener('click', function () {
            var marker = this;
            that.places.getDetails({ placeId: this.placeResult.place_id },
              function (place, status) {
                /*if (status !== google.maps.places.PlacesServiceStatus.OK) {
                  return;
                }*/
                //that2.infoWindow.setContent('<img class="mapicon" src="' + place.icon + '"/> <strong>' + place.name + '</strong><br><br>' + place.vicinity + '<br><br>' + place.formatted_phone_number);
                //that2.infoWindow.open(that2.map, marker);
                that2.objdesc = '<img class="mapicon" src="' + place.icon + '"/> <strong>' + place.name + '</strong><br><br>' + place.vicinity;
                if (place.formatted_phone_number != undefined) {
                  //alert(place.formatted_phone_number);
                  that2.objdesc  = that2.objdesc + '<br><br>' + place.formatted_phone_number
                }
                that2.openModal();
                
              });
          });

          //setTimeout(dropMarker(i), i * 100);
          //addResult(results[i], i);
        }
      }
    });

    //console.log(this.markers);
  }

  showInfoWindow(marker) {
    //
  }

  clearMarkers() {
    for (var i = 0; i < this.markers.length; i++) {
      if (this.markers[i]) {
        this.markers[i].setMap(null);
      }
    }
    this.markers = [];
  }

  /*addMarker(location) {

    let that = this;

    var marker = new google.maps.Marker({
      position: location,
      map: that.map
    });
  }*/

  findCoors() {

    let that = this;

    let loadingPopup = this.loadingCtrl.create({
      content: 'ищем вас...'
    });


    if (this.params.runned_in_app=='1') {
      //Поиск местоположения нативным модулем
      console.log('Ionic native geolocation...');
      loadingPopup.present();

      this.geolocation.getCurrentPosition().then((resp) => {
        this.lat = resp.coords.latitude;
        this.lng = resp.coords.longitude;

        var pos = {
          lat: this.lat,
          lng: this.lng
        };

        that.infoWindow.setPosition(pos);
        that.infoWindow.setContent('Вы здесь');
        that.infoWindow.open(that.map);
        that.map.setCenter(pos);

        loadingPopup.dismiss();

      }).catch((error) => {
        alert('Невозможно определить ваше местоположение');
        loadingPopup.dismiss();
      });
    } else {
      //Поиск местоположения методом гугл карт через HTML5
      // Try HTML5 geolocation.
      console.log('HTML5 geolocation...');
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          var pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };

          that.infoWindow.setPosition(pos);
          that.infoWindow.setContent('Вы здесь');
          that.infoWindow.open(that.map);
          that.map.setCenter(pos);

          loadingPopup.dismiss();

        }, function () {
          alert('Невозможно определить ваше местоположение');
        });
      } else {
        // Browser doesn't support Geolocation
        alert('Браузер не позволяет определить ваше местоположение');
      }     
    }
  }

  openList() {
    // That's right, we're pushing to ourselves!
    this.navCtrl.push(MaplistPage, {
      gorod: this.gorod
    });
  }

  handleLocationError(browserHasGeolocation, infoWindow, pos) {
    infoWindow.setPosition(pos);
    infoWindow.setContent(browserHasGeolocation ?
      'Error: The Geolocation service failed.' :
      'Error: Your browser doesn\'t support geolocation.');
    infoWindow.open(this.map);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MapPage');
  }

  ionViewWillEnter() {
    this.params.stat('map');    
  }     

}



// WEBPACK FOOTER //
// ./src/pages/map/map.ts